// config/api.js (o al inicio donde lo necesites)
const fromEnv = process.env.REACT_APP_BACKEND_URL;           // CRA solo en build/start
const DEFAULT_BASE = "/api";                                  // para Docker/compose con Nginx
export const API_BASE = (fromEnv || DEFAULT_BASE).replace(/\/+$/, "");
